import { Waypoint } from 'react-waypoint';
import { FC, ReactNode, useState } from 'react';
import { useAsyncEffect } from '../../support/useAsyncEffect';
import { MixPanelEventEmitter } from '../../metrics/MixPanelEventEmitter';
import { useInstance } from '@meraki-internal/react-dependency-injection';

export type IWayPointCardProps = {
    children: ReactNode;
    scrollingElRef: React.RefObject<HTMLIonContentElement>;
    bottomOffset?: string | number;
    trackingEvent?: string;
    onBottomEntered?: () => void;
};

export const WithWaypoint: FC<IWayPointCardProps> = ({
    children,
    scrollingElRef,
    bottomOffset = '-20px',
    trackingEvent,
    onBottomEntered
}) => {
    const mixpanel = useInstance(MixPanelEventEmitter);
    const [scrollerRef, setScrollerRef] = useState<HTMLElement | null | undefined>();

    useAsyncEffect(async () => {
        if (scrollingElRef.current) {
            const scrollEl = await scrollingElRef.current.getScrollElement();
            setScrollerRef(scrollEl);
        }
    }, [scrollingElRef.current]); // eslint-disable-line react-hooks/exhaustive-deps

    const onEnter = () => {
        if (onBottomEntered) {
            onBottomEntered();
        }

        if (trackingEvent) {
            mixpanel.track(trackingEvent);
        }
    };

    return (
        scrollerRef && (
            <>
                {children}
                <Waypoint
                    //debug
                    onEnter={onEnter}
                    bottomOffset={bottomOffset}
                    scrollableAncestor={scrollerRef}
                ><div></div></Waypoint>
            </>
        )
    );
};
